import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { jwtDecode } from 'jwt-decode';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router,
    private _snackBar: MatSnackBar,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const authToken = this.authService.getToken(); // Get the token from the AuthService

    // If token exists and is expired
    if (authToken && this.isTokenExpired(authToken)) {
      //
      //   // Emit an event that session has expired
      this.authService.emitSessionExpired();

      //   // Navigate to login page
      this.router.navigate(['/login']).then(() => {
        // Optionally show a session expired message
        sessionStorage.clear();
        // sessionStorage.removeItem('authToken');
        // sessionStorage.removeItem('userName');
        // sessionStorage.removeItem('userId');
        this.authService.showSessionExpiredMessage();
        window.location.reload();
      });

      // Prevent further requests
      return throwError(() => new Error('Session expired'));
    }

    // If token is valid or doesn't exist, pass the request through
    if (authToken) {
      const clonedRequest = req.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`,
          'Access-Control-Allow-Origin': '*',
        },
      });
      return next.handle(clonedRequest);
    }

    // If no token exists, pass the request as is
    return next.handle(req).pipe(
      catchError((error) => {
        // If an error occurs, handle it globally (optional)
        console.error('Error occurred:', error);
        return throwError(error);
      }),
    );
  }

  // Check if the token is expired
  isTokenExpired(token: string): boolean {
    try {
      const decodedToken: any = token ? jwtDecode(token) : null;
      const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
      sessionStorage.setItem('userName', decodedToken.sub);
      sessionStorage.setItem('userId', decodedToken.userId);
      sessionStorage.setItem('name', decodedToken.name);
      // sessionStorage.setItem('role', decodedToken.role); // currently not available
      return decodedToken.exp < currentTime;
    } catch (error) {
      // If token is invalid or can't be decoded, consider it expired
      return true;
    }
  }
}
